import React, { useState } from "react";

// Name, target URL and active, for creating a QR code or editing one
export default function QRForm({ initial, submitLabel, onSubmit, onCancel }) {
  const [name, setName] = useState(initial?.name || "");
  const [targetUrl, setTargetUrl] = useState(initial?.targetUrl || "https://");
  const [active, setActive] = useState(initial?.active ?? true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await onSubmit({ name, targetUrl, active });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="form" onSubmit={handleSubmit}>
      <label>
        İsim
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="ör. Broşür – Ekim kampanyası" required />
      </label>
      <label>
        Hedef URL
        <input type="url" value={targetUrl} onChange={(e) => setTargetUrl(e.target.value)} required />
      </label>
      <label className="check">
        <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
        Aktif (pasifken okutan kişi "aktif değil" sayfası görür)
      </label>
      {error && <div className="error">{error}</div>}
      <div className="form-actions">
        <button className="btn btn-primary" type="submit" disabled={busy}>
          {submitLabel}
        </button>
        {onCancel && (
          <button className="btn" type="button" onClick={onCancel}>
            Vazgeç
          </button>
        )}
      </div>
    </form>
  );
}
